import EmptyRouterView from '@/components/common/EmptyRouterView'

import Jobs from '@/views/Jobs/Index'
import JobsJob from '@/views/Jobs/Job/Index'
import JobsJobShipmentsOrder from '@/views/Shipments/ShipmentsOrders/ShipmentsOrder/Index'

import OrderComponentsList from '@/views/Jobs/Jobs/OrderComponentsList'

export default [
    {
        path: '/jobs',
        component: EmptyRouterView,
        meta: {
            title: 'Zlecenia',
            menuRendered: true,
            menuTitle: 'Zlecenia',
            permission: 'jobs',
            requiresAuth: true,
            icon: 'mdi-inbox-multiple',
        },
        children: [
            {
                path: '',
                name: 'jobs',
                component: Jobs,
                meta: {
                    title: 'Zlecenia',
                    requiresAuth: true,
                    permission: 'jobs',
                },
            },
            {
                path: '/jobs/:jobId',
                component: EmptyRouterView,
                meta: {
                    parentName: 'jobs',
                    requiresAuth: true,
                    permission: 'jobs',
                },
                children: [
                    {
                        path: '',
                        name: 'jobsJob',
                        component: JobsJob,
                        meta: {
                            title: 'Zlecenia / Zlecenie',
                            requiresAuth: true,
                            permission: 'jobs',
                        },
                    },
                    {
                        path: '/jobs/:jobId/shipping-orders/:shippingOrderId',
                        component: EmptyRouterView,
                        meta: {
                            parentName: 'jobsJob',
                            requiresAuth: true,
                            permission: 'shipping_orders'
                        },
                        children: [
                            {
                                path: '',
                                name: 'jobsJobShipmentsOrder',
                                component: JobsJobShipmentsOrder,
                                meta: {
                                    title: 'Zlecenia / Zlecenie / Zlecenie spedycyjne',
                                    requiresAuth: true,
                                    permission: 'shipping_orders'
                                }
                            }
                        ]
                    }
                ]
            },
            {
                path: '/jobs/jobs/create',
                name: 'orderComponentsList',
                component: OrderComponentsList,
                meta: {
                    title: 'Zlecenia / Tworzenie zlecenia',
                    requiresAuth: true,
                    permission: 'jobs',
                },
            },

        ]
    },
]